<footer class="footer">
    <div class="container bottom">
      <div class="copyright">{{'footer.copyright'|translate}}</div>
      <a href="http://www.siemens.com/corporate_info" target="_blank" class="link">{{'footer.corporate'|translate}}</a>
      <a href="http://www.siemens.com/privacy" target="_blank" class="link">{{'footer.privacy'|translate}}</a>
      <a href="http://www.siemens.com/terms_of_use" target="_blank" class="link">{{'footer.terms'|translate}}</a>
      <a href="http://www.siemens.com/digital_id_en" target="_blank" class="link">{{'footer.id'|translate}}</a>
    </div>
  </footer>
  